import { useState } from "react";
import { Button } from "react-bootstrap";
import ConfirmModal from "../common/ConfirmModal";
import Utils from "../../utils";
import { useLocation } from "react-router-dom";
import useRunbookTitle from "../../hooks/runbookTitle";
import { runbookStepActions } from "../../actions/runbookStep.actions";
import { useDispatch } from "react-redux";

function RunbookDetailsEmpty(props) {
  const [displayModal, setDisplayModal] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { runbookGuid } = useRunbookTitle();

  const handleConfirm = () => {
    let requestParameters = {
      runbookVersion: 1,
      runbookId: Utils.getQueryStringParams(location)["runbookId"],
      runbookGuid: runbookGuid,
    };

    dispatch(runbookStepActions.addBlank(requestParameters));

    setDisplayModal(false);
  };

  return (
    <div className="pt-4">
      <div className="d-grid gap-2">
        <Button
          variant="primary"
          size="lg"
          onClick={() => setDisplayModal(true)}
        >
          Add blank step
        </Button>
      </div>

      <ConfirmModal
        show={displayModal}
        title="Create Step"
        question={`Are you sure you want to create the first blank step?`}
        noButtonText="No"
        yesButtonText="Yes, please"
        handleClose={() => {
          setDisplayModal(false);
        }}
        handleConfirm={() => {
          handleConfirm();
        }}
      />
    </div>
  );
}

export default RunbookDetailsEmpty;
